module.exports = __webpack_public_path__ + "img/ntk_nav_edit_w.eebf7e17.svg";